<template>
  <el-row :gutter="0">
    <el-col :span="24">
      <h3 v-if="isMobile" style="color: #409eff">
        Форма добавления автомобиля
      </h3>
      <p>Введите номер автомобиля:</p>
      <el-input
        v-model="plate"
        style="width: 50%; margin-right: 10px"
        placeholder="Введите номер автомобиля с регионом"
        @focus="focus"
        @blur="blur"
      />
      <el-button type="primary" @click="checkPlate(1)">Добавить авто</el-button>

      <ul v-if="typePlateFind !== 0" class="fast_select">
        <li v-if="typePlateFind === 1">Результат поиска:</li>
        <li v-if="typePlateFind === 1" class="c-quick-pick__item">
          Автомобиль найден в вашем списке:<br />
          <a href class="c-link" @click.prevent="editAuto">
            редактировать автомобиль {{ findPlate }}
          </a>
        </li>
        <li v-if="typePlateFind === 2">Автомобиль добавлен:</li>
        <li v-if="typePlateFind === 2" class="c-quick-pick__item">
          <a href class="c-link" @click.prevent="editAuto">
            Редактировать автомобиль {{ findPlate }}
          </a>
        </li>
      </ul>
    </el-col>
  </el-row>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { numAutoValidator } from '@/helpers/validate-req'

const AutoRepository = RepositoryFactory.get('auto')

export default {
  name: 'AddNewAuto',
  props: {
    carrierInn: {
      type: String,
      default: '',
    },
    carrierName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      typePlateFind: 0, // 0 не искали, 1 собственный транспорт недозаполнен, 2 не найден
      plate: '',
      findPlate: '',
      idAuto: 0,
    }
  },
  methods: {
    focus() {
      this.$emit(
        'helper',
        'Введите номер автомобиля, полностью в формате a000aa00, регистр букв и язык значения не имеют',
      )
    },
    blur() {
      this.plate = this.plate.replace(/\s+/g, ' ').trim()

      if (numAutoValidator(this.plate)) {
        this.$emit(
          'helper',
          'Введите номер автомобиля, полностью в формате a000aa00, регистр букв и язык значения не имеют',
        )
      }
    },
    editAuto() {
      this.$emit('editAuto', this.idAuto)
    },
    setAutoId(plate) {
      let data = { innCarrier: this.carrierInn, nameCarrier: this.carrierName }

      AutoRepository.addCar(plate, data)
        .then(res => {
          this.$emit('saved', { ...res.data, user_id_match: 0 })
          this.checkPlate(2)
        })
        .catch(err => this.errHandler(err))
    },

    checkPlate(flag) {
      this.$emit('clear')

      if (numAutoValidator(this.plate)) {
        this.$message({
          showClose: true,
          message: `Введите номер автомобиля, полностью в формате a000aa00, регистр букв и язык значения не имеют`,
          type: 'error',
          duration: 5000,
        })

        return
      }
      if (!this.plate) {
        this.typePlateFind = 0
      } else {
        AutoRepository.findCar(this.plate).then(response => {
          if (response !== false) {
            this.idAuto = response
            this.typePlateFind = flag
            this.findPlate = this.plate
          } else {
            this.setAutoId(this.plate)
          }
        })
      }
    },
  },
}
</script>
